// extracted by mini-css-extract-plugin
export default {"description":"industry_description__IqCgg","content":"industry_content__-8-o1"};